module.exports = __webpack_public_path__ + "img/1600m.3e8f64ed.png";